import React, { useState } from "react";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import ReportRunner from "../components/ReportRunner";
import { reportList } from "../reports";

// Phase 1: live reports appear as clickable links; committed roadmap families are muted non-clickable rows.
const COMING_SOON = [];

export default function Reports() {
   const [openId, setOpenId] = useState(null);
   return (
      <React.Fragment>
         <Header />
         <div className="main main-app reports-page p-3 p-lg-4 p-xxl-5">
            {!openId && (
               <>
                  <h2 className="main-title fs-4 mb-1">Reports</h2>
                  <ul style={{ listStyle: "none", padding: 0, margin: 0, maxWidth: 600 }}>
                     {reportList.map((r) => (
                        <li key={r.id} style={{ padding: "10px 0", borderBottom: "1px solid #dee2e6" }}>
                           <a
                              href="#"
                              style={{ color: "#0073bb", fontWeight: 400, fontSize: 14, textDecoration: "none" }}
                              onClick={(e) => { e.preventDefault(); setOpenId(r.id); }}
                           >
                              {r.title}
                           </a>
                           <span style={{ color: "#6c757d", fontSize: 13, marginLeft: 12 }}>
                              Statement vs ERP mismatches
                           </span>
                        </li>
                     ))}
                     {COMING_SOON.map((item) => (
                        <li key={item.name} style={{ padding: "10px 0", borderBottom: "1px solid #dee2e6" }}>
                           <span style={{ color: "#6c757d", fontSize: 14, fontWeight: 400 }}>{item.name}</span>
                           <span style={{ color: "#6c757d", fontSize: 13, marginLeft: 12 }}>Coming soon · {item.desc}</span>
                        </li>
                     ))}
                  </ul>
               </>
            )}
            {openId && (
               <>
                  <div className="mb-3" style={{ fontSize: 13 }}>
                     <a
                        href="#"
                        style={{ color: "#0073bb", textDecoration: "none" }}
                        onClick={(e) => { e.preventDefault(); setOpenId(null); }}
                     >
                        Reports
                     </a>
                     <span style={{ color: "#6c757d" }}> ▸ {reportList.find((r) => r.id === openId)?.title}</span>
                  </div>
                  <ReportRunner reportId={openId} />
               </>
            )}
            <Footer />
         </div>
      </React.Fragment>
   );
}
